import { useMemo } from 'react'
import type { Zone } from '../../../../zones/types'
import {
  convertToGeoJSON,
  ensurePolygonClosed,
} from '../../../utils/mapHelpers'

interface UseGeoSourcesParams {
  mapZones: Zone[]
  editingZoneId?: string | null
}

export const useGeoSources = ({
  mapZones,
  editingZoneId,
}: UseGeoSourcesParams) => {
  const zonesGeoJSON = useMemo(() => {
    const features: GeoJSON.Feature[] = mapZones
      .filter(zone => {
        if (zone.id === editingZoneId) return false
        return zone.coordinates && zone.coordinates.length > 0
      })
      .map(zone => {
        const geoJsonCoords = convertToGeoJSON(zone.coordinates!)
        const closedCoords = ensurePolygonClosed(geoJsonCoords)

        const rawScore = Number(zone.score)
        const score = !isNaN(rawScore) ? rawScore : 0

        return {
          type: 'Feature' as const,
          id: zone.id,
          geometry: {
            type: 'Polygon' as const,
            coordinates: [closedCoords],
          },
          properties: {
            zoneId: zone.id,
            name: zone.name,
            score,
            area: zone.area ?? 0,
          },
        } as GeoJSON.Feature
      })

    return { type: 'FeatureCollection' as const, features }
  }, [mapZones, editingZoneId])

  return { zonesGeoJSON }
}
